import businessClient from 'src/services/clients/business'

import { IMeta, ILocation, ISetLocation } from 'src/common/interfaces/index.js'

const IResponse = { meta: IMeta, data: { url: '', endpoint: '' } }
const ILocationsResponse = { meta: IMeta, data: { list: [ILocation] } }
const ISetLocationResponse = { meta: IMeta, data: { update: [ISetLocation] } }

export const integrationUberEats = {
  /**
   * @param {{redirect_url: string, store_id: number}} filter
   * @return {Promise<IResponse>}
   */
  getUrl(filter, signal) {
    return businessClient().post('apppair/ubereat/auth/get-link', { filter }, { signal })
  },

  /**
   * @return {Promise<IResponse>}
   */
  pairSystem(signal) {
    return businessClient().post('apppair/ubereat/pair-system', {}, { signal })
  },

  /**
   * @param {{ id: number }} data
   * @return {Promise<ILocationsResponse>}
   */
  locationsList(signal) {
    return businessClient().post('apppair/ubereat/location/portal/list', {}, { signal })
  },

  /**
   * @param {{ id:number, store_id:number }} data
   * @return {Promise<ISetLocationResponse>}
   */
  setLocations(data, signal) {
    return businessClient().post('apppair/ubereat/location/set', { data }, { signal })
  },

  /**
   * @param {{ id:number }} data
   * @return {Promise<ISetLocationResponse>}
   */
  unSetLocations(data, signal) {
    return businessClient().post('apppair/ubereat/location/unset', { data }, { signal })
  },

  /**
   * @return {ISquareResourceResponse}
   */
  disconnect(signal) {
    return businessClient().post('apppair/ubereat/disconnect', {}, { signal })
  },

  /**
   * @param {{ store_id: number, uber_venue_id: string, uber_venue_name: string }} data
   * @return {Promise<IResponse>}
   */
  pairStore(data, signal) {
    return businessClient().post('apppair/ubereat/pair-branch', { data }, { signal })
  },

  /**
   * @param {{store_id: number, auto_accept_minute: number }} data
   * @return {Promise<IResponse>}
   */
  autoAccept(data, signal) {
    return businessClient().post('apppair/ubereat/auto-accept', { data }, { signal })
  },
}
